import {useEffect, useRef} from 'react';
import {useAnalytics} from './useAnalytics';
import {ANALYTICS_SOURCE_TYPES} from '@/services/analytics/constants';
import {useGetLocaleQuery} from '@/services/api/locale-api';

export const useEcommercePageView = ({pageType, pageSubType, zone} = {}) => {
  const {pageView} = useAnalytics();
  const {data: locale, isSuccess, isError} = useGetLocaleQuery({zone}, {skip: !zone});
  const hasTrackedPageView = useRef(false);

  useEffect(() => {
    if (hasTrackedPageView.current) return;

    if (isError || isSuccess) {
      pageView(pageType, pageSubType, locale || null, {sourceType: ANALYTICS_SOURCE_TYPES.LOCALE});
      hasTrackedPageView.current = true;
    }
  }, [isSuccess, isError, locale, pageType, pageSubType, pageView]);
};
